<template>
  <main class="container">
    <app-rooms></app-rooms>
  </main>
</template>

<script>
import {
  mapGetters
  // mapState
} from 'vuex'
import Rooms from '@/components/rooms/Rooms'
// import l from '@/vendor/logger'

export default {
  name: 'Home',

  created () {
    if (this.$store.state.rid || this.$store.state.mode) {
      this.$store.commit('setRid', null)
      this.$store.commit('room/clearRoom')
      this.$store.dispatch('setMode', null)
    }
    this.$store.dispatch('rooms/bindRooms')
  },

  beforeDestory () {
    this.unbind()
  },

  beforeRouteLeave (to, from, next) {
    this.unbind()
    next()
  },

  data () {
    return {
      mainView: null
    }
  },

  methods: {
    unbind () {
      this.$store.dispatch('rooms/unbindRooms')
    }
  },

  computed: {
    ...mapGetters('user', [
      'isSignIn',
      'user'
    ])
  },

  components: {
    'app-rooms': Rooms
  }
}
</script>

<style scoped>
</style>
